// Third party library
import _ from 'lodash';
import { connect } from "react-redux";
import React from "react";

// Redux
import { openLoader, closeLoader } from "../../../../../redux-store/loader";
import { openModal, closeModal } from '../../../../../redux-store/modal';
import History from '../../../../../history';

// Components
import { Segment, Header, Table, Icon, Pagination, Menu, Form, Input, Button } from "semantic-ui-react";

// Models
import SessionModel from "../../../../../data/models/sessions";

// Locales
import I18n from "../../../../../i18n";

class SequenceRules extends React.Component {

  constructor(props) {

    super(props);

    this.state = {
      rules: [],
      filteredRules: [],
      pageNumber: 1,
      recordsPerPage: 10,
      activePage: 1,
      search: '',
      totalPages: 0,
      column: '',
      direction: null,
    };

  }

  componentDidMount() {

    this.getRules();

  }

  getRules = async () => {

    const { closeLoader, openLoader, openModal, closeModal } = this.props;

    const { recordsPerPage } = this.state;

    let message = {
      headerTitle: "Error",
      title: I18n.t('messages.modal.commonError'),
      buttons: [

        {
          text: I18n.t('actions.accept'),
          callback: () => closeModal()

        }

      ]

    };

    try {

      openLoader();
      const rules = await SessionModel.getRules();
      this.setState({ rules: rules.data, filteredRules: _.orderBy(rules.data, ['name'], ['asc']), totalPages: Math.ceil(rules.data.length / recordsPerPage) });

    } catch (error) {

      console.error("error getRules", error);
      closeLoader();
      openModal(message);

    } finally {

      closeLoader();

    }

  };

  onEditRule = (ruleId) => History.push(`/home/personalized-sequences/rules/${ruleId}`);

  onAddRule = () => History.push('/home/personalized-sequences/rules/new');

  onRemoveRule = ruleId => {

    let self = this;
    let message = {
      title : I18n.t('personalizedSequence.rules.removeRule'),
      buttons : [{
        text : I18n.t('actions.accept'),
        callback : async () => {
          self.removeRule(ruleId);
          self.props.closeModal();
        }
      },
      {
        text : I18n.t('actions.cancel'),
        callback : () => self.props.closeModal()
      }]
    };

    this.props.openModal(message);

  }

  removeRule = async ruleId => {

    try {

      this.props.openLoader();
      await SessionModel.deleteRule(ruleId);
      
    } catch (error) {

      console.error("error removeRule", error);
      this.props.openModal(this.errorMessage);
      
    } finally {

      this.props.closeLoader();
      this.getRules();

    }

  }

  onPageChange = (e, pageInfo) => this.setState({ activePage: pageInfo.activePage });

  paginate = () => this.state.filteredRules.slice((this.state.activePage - 1) * this.state.recordsPerPage, this.state.activePage * this.state.recordsPerPage);

  onFilterListByRuleName = search => this.setState({ search }, () => this.onFilter());

  onFilter = () => {

    let filter = this.state.rules;

    const { recordsPerPage, search } = this.state;

    if (search.length) {

      filter = filter.filter(rule => {

        if (_.get(rule, 'name', false)) {

          const name = rule.name.toLowerCase();
          return name.indexOf(search.toLowerCase()) > -1

        }

        return false;

      });

    }

    this.setState({ filteredRules: filter, totalPages: Math.ceil(filter.length / recordsPerPage), activePage: 1 });

  }

  handleSort = clickedColumn => () => {

    const { column, filteredRules, direction } = this.state;

    if (column !== clickedColumn) {

      this.setState({
        column: clickedColumn,
        filteredRules: _.sortBy(filteredRules, [clickedColumn]),
        direction: 'ascending',
      })

      return;

    }

    this.setState({
      filteredRules: filteredRules.reverse(),
      direction: direction === 'ascending' ? 'descending' : 'ascending'
    });

  }

  renderList = () => {

    const { activePage, search, totalPages, column, direction } = this.state;

    return (
      <React.Fragment>
        <Segment>
          <div>
            <Form>
              <Form.Group inline>
                <Form.Field>
                  <label>Nombre de regla</label>
                  <Input value={search} onChange={e => this.onFilterListByRuleName(e.target.value)} placeholder="Buscar por nombre de regla" />
                </Form.Field>
              </Form.Group>
            </Form>
          </div>
        </Segment>
        <Segment>
          <Table celled selectable sortable>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell onClick={this.handleSort('name')} sorted={column === 'name' ? direction : null}>{I18n.t('personalizedSequence.rules.name')}</Table.HeaderCell>
                <Table.HeaderCell>{I18n.t("actions.edit")}</Table.HeaderCell>
                <Table.HeaderCell>{I18n.t("actions.remove")}</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {this.paginate().map(rule => (
                <Table.Row key={rule._id} onClick={() => this.onEditRule(rule._id)}>
                  <Table.Cell >{rule.name}</Table.Cell>
                  <Table.Cell style={{ textAlign: "center" }}>
                    <Icon className="c-pointer" name="edit" size="large"></Icon>
                  </Table.Cell>
                  <Table.Cell style={{ textAlign: "center" }} onClick={(e) => e.stopPropagation()}>
                    <Icon className="c-pointer" name="eraser" size="large" onClick={() => this.onRemoveRule(rule._id)}></Icon>
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
            <Table.Footer>
              <Table.Row>
                <Table.HeaderCell colSpan={5}>
                  <Menu floated='right'>
                    <Pagination
                      onPageChange={this.onPageChange}
                      totalPages={totalPages}
                      ellipsisItem={null}
                      activePage={activePage}
                      boundaryRange={0}

                    />
                  </Menu>
                  <div style={{ clear: "both" }}></div>
                </Table.HeaderCell>
              </Table.Row>
              <Table.Row>
                <Table.HeaderCell colSpan={9}>
                  <Button type='button' floated='right' primary onClick={this.onAddRule}>{I18n.t('personalizedSequence.rules.add')}</Button>
                  <div style={{ clear: "both" }}></div>
                </Table.HeaderCell>
              </Table.Row>
            </Table.Footer>
          </Table>
        </Segment>
      </React.Fragment>
    );

  };

  render() {
    return (
      <React.Fragment>
        <Segment>
          <Header as="h3">{I18n.t("personalizedSequence.rules.title")}</Header>
          {this.renderList()}
        </Segment>
      </React.Fragment>
    )
  }
}

export default connect(null, { openLoader, closeLoader, openModal, closeModal })(SequenceRules);;
